<template>
  <v-dialog width="800px" :value="value" persistent scrollable>
    <v-card class="kbLight">
      <v-toolbar class="kbPink" dark flat>
        <div class="text-h6">{{ $t('general.pickAnOutcomeForTheTask') }}</div>
        <v-spacer></v-spacer>
        <v-btn icon @click="toggleModal(false)">
          <v-icon>clear</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-form ref="form">
          <v-row justify="center">
            <v-col class="text-center kbGrayText--text mt-10" cols="12" >
              <h3>{{ $t('general.pickAnOutcome') }}</h3>
            </v-col>

            <v-col cols="12" class="d-flex justify-center">
              <v-select v-model="selectedOutcome"
                        background-color="kbWhite"
                        color="kbDarkBlueText"
                        :items="filteredTaskOutcomes"
                        item-text="name"
                        item-value="value"
                        :loading="loadingTaskOutcomes"
                        solo
                        :rules="[rules.required]"
                        :label="$t('general.pickAnOutcome')" />
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="red"
               class="mr-2"
               outlined
               @click="toggleModal()">{{ $t('general.cancel') }}</v-btn>
        <v-btn color="kbPink"
               dark
               :loading="loadingSubmit"
               @click="submit">{{ $t('general.save') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import notifications from '@/libs/notifications'
import rules from '@/libs/rules'
export default {
  computed: {
    ...mapGetters(['appUuid', 'companyUuid']),
    ...mapState({
      taskOutcomes: state => state.usersTasks.taskOutcomes
    }),
    filteredTaskOutcomes () {
      const { type } = this.selectedTask
      if (!type) return this.taskOutcomes
      return this.taskOutcomes.filter(item => item.group === type)
    },
    taskResultField () {
      const { type = '' } = this.selectedTask
      switch (type) {
        case 'call':
          return 'call'
        case 'email':
          return 'emailResult'
        case 'social':
          return 'socialResult'
        default:
          return ''
      }
    }
  },
  created () {
    this.getTaskOutcomes()
  },
  data () {
    return {
      loadingSubmit: false,
      loadingTaskOutcomes: false,
      rules,
      selectedOutcome: ''
    }
  },
  methods: {
    async getTaskOutcomes () {
      try {
        await this.$store.dispatch('getTaskOutcomes')
      } catch (e) {
        notifications.error(e)
      }
    },
    async submit () {
      try {
        if (!this.$refs.form.validate() || this.loadingSubmit) return
        this.loadingSubmit = true
        const task = { ...this.selectedTask }
        const { extraData, ...all } = task
        if (this.taskResultField) {
          extraData[this.taskResultField] = this.selectedOutcome
          await this.$store.dispatch('updateUserTask', {
            companyId: this.companyUuid,
            appId: this.appUuid,
            userId: this.selectedUserId,
            task: { extraData, ...all }
          })
          this.$emit('getTasks')
        }
        this.toggleModal()
      } catch (e) {
        notifications.error(e)
        console.error(e)
      } finally {
        this.loadingSubmit = false
      }
    },
    toggleModal () {
      this.$refs.form.reset()
      this.$emit('input', false)
    }
  },
  props: {
    selectedTask: {
      type: Object,
      default: () => {}
    },
    selectedUserId: {
      type: String,
      default: ''
    },
    value: {
      type: Boolean,
      default: false
    }
  }
}
</script>
